export default __webpack_public_path__ + "static/jason-bitmoji-7a2ecfccbff49900ced102cc48c3d667.png";